export default __webpack_public_path__ + "static/media/hexagon-inner-2.004e9f78.svg";